import React from 'react'
import ventilations from '../data/ventilations'

class VentilationSelect extends React.Component {
    render() {
        return (
            <select {...this.props}>
                <option></option>
                { ventilations.map(ventilation => (
                    <option key={ventilation.name} value={ventilation.name}>{ventilation.name}</option>
                ))}
            </select>
        )
    }
}

export default VentilationSelect


// WEBPACK FOOTER //
// ./src/components/VentilationSelect.js